import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-daterange', 'TIME_START', 'Начальное время');
Labels.set('ui-daterange', 'TIME_END', 'Конечное время');
